var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":require("../assets/GDQ-Associates-White.svg"),"width":"400","height":"60"}})}
var staticRenderFns = []

export { render, staticRenderFns }